import GnbTabs from './GnbTabsContainer';

export default GnbTabs;
